<script>
import {
  memberListAgentadminComputed,
  memberListAgentadminMethods,
} from '@state/helpers/member-list-agentadmin'
import store from '@state/store'
import { cloneDeep } from 'lodash'

export default {
  props: {
    type: {
      validator: function(value) {
        return !!~['add', 'view', 'edit'].indexOf(value)
      },
      default: 'add',
    },
    filterObj: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      currentUser: store.getters['auth/getCurrentUser'],
      fields: {},
      optionsStatus: [],
      itemQuestions: [],
      items: [
        {
          label: '性別',
          name: 'gender',
          type: 'radio',
          options: [
            { label: '男性', value: '1' },
            { label: '女性', value: '0' },
            { label: '指定なし', value: '2' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '年齢',
          unit: '歳',
          name: 'age',
          lower: 'age_range_lower',
          upper: 'age_range_upper',
          type: 'number-ranger',
          rules: {
            required: false,
            min: 0,
            max: 150,
            valueRange: { min: 0, max: 150 },
          },
        },
        {
          label: 'ステータス',
          name: 'member_status',
          type: 'checkbox-group',
          class: 'checkbox-group-w-50',
          rules: {
            required: false,
          },
        },
        {
          label: '備考',
          type: 'input',
          name: 'admin_note',
          placeholder: 'キーワードをスペースで区切り入力してください',
          rules: {
            required: false,
            max: 1000,
          },
        },
      ],
      itemsBottom: [
        {
          label: '最終計測日',
          name: 'last_measure_date',
          type: 'date-ranger',
          lower: 'last_measure_date_lower',
          upper: 'last_measure_date_upper',
          rules: {},
          rulesStart: {
            timeBeforeNow: true,
          },
          rulesEnd: {
            timeBeforeNow: true,
          },
        },
        {
          label: '体重',
          name: 'weight_range',
          type: 'checkbox-group',
          options: [
            { label: '不足', value: '1' },
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '高い', value: '4' },
            { label: '超過', value: '5' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '体脂肪率',
          name: 'body_fat_rate_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '高い', value: '4' },
            { label: '超過', value: '5' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '体水分率',
          name: 'body_water_rate_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '十分', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '基礎代謝',
          name: 'BMR_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '高い', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '体内年齢',
          name: 'metabolic_age_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '高い', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '骨格筋',
          name: 'muscle_rate_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '高い', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '骨量',
          name: 'bone_mass_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '高い', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '皮下脂肪',
          name: 'subcutaneous_fat_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '高い', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '内臓脂肪',
          name: 'visceral_fat_range',
          type: 'checkbox-group',
          options: [
            { label: '標準', value: '2' },
            { label: '高い', value: '3' },
            { label: '超過', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: 'BMI',
          name: 'BMI_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '高い', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '総筋肉量',
          name: 'muscle_mass_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '十分', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: 'タンパク質',
          name: 'protein_range',
          type: 'checkbox-group',
          options: [
            { label: '低い', value: '2' },
            { label: '標準', value: '3' },
            { label: '十分', value: '4' },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: '体重変位',
          name: 'weight_differ',
          unit: 'kg',
          lower: 'weight_differ_lower',
          upper: 'weight_differ_upper',
          type: 'number-ranger',
          rules: {
            required: false,
            max: 100,
            min: -100,
            valueRange: { min: -100, max: 100 },
          },
        },
        {
          label: '体脂肪変位',
          name: 'body_fat_rate_differ',
          unit: '%',
          lower: 'body_fat_rate_differ_lower',
          upper: 'body_fat_rate_differ_upper',
          type: 'number-ranger',
          rules: {
            required: false,
            max: 100,
            min: -100,
            valueRange: { min: -100, max: 100 },
          },
        },
      ],
    }
  },
  computed: {
    ...memberListAgentadminComputed,
    add() {
      return this.type === 'add'
    },
    view() {
      return this.type === 'view'
    },
    edit() {
      return this.type === 'edit'
    },
  },
  watch: {
    fields: {
      handler() {
        if (JSON.stringify(this.fields) !== JSON.stringify(this.dataInit)) {
          this.$emit('change', this.fields)
          this.dataInit = cloneDeep(this.fields)
        }
      },
      deep: true,
    },
    filterObj() {
      if (this.filterObj) {
        const data = this.filterObj
        this.fields = cloneDeep(data)
      }
    },
  },
  created() {
    this.getStatus()
    if (this.filterObj) {
      const data = this.filterObj
      this.dataInit = cloneDeep(data)
      this.fields = cloneDeep(data)
    }
  },
  methods: {
    ...memberListAgentadminMethods,
    handleChangeRangeData(lower, upper, value) {
      const fields = {}
      if (typeof value.left === 'string') {
        const valueInt = parseInt(value.left)
        if (Math.abs(valueInt) >= 10000000000 || isNaN(valueInt)) {
          fields[lower] = value.left
        } else {
          fields[lower] = valueInt
        }
      } else {
        fields[lower] = value.left
      }
      if (typeof value.right === 'string') {
        const valueInt = parseInt(value.right)
        if (Math.abs(valueInt) >= 10000000000 || isNaN(valueInt)) {
          fields[upper] = value.right
        } else {
          fields[upper] = valueInt
        }
      } else {
        fields[upper] = value.right
      }
      this.fields = { ...this.fields, ...fields }
    },
    handleChangeCheckboxGroup(name, value) {
      const fields = {}
      fields[name] = value.join(',')
      this.fields = { ...this.fields, ...fields }
    },
    handleChangeDateRanger(lower, upper, value) {
      const fields = {}
      fields[lower] = value.date_start
      fields[upper] = value.date_end
      this.fields = { ...this.fields, ...fields }
    },
    getCheckboxGroupOptions(item) {
      if (item.name === 'member_status') {
        return this.optionsStatus
      }
      return item.options || []
    },
    async getStatus() {
      const response = await this.fetchingStatus({
        id: this.currentUser?.agent.id,
      })
      if (response) {
        const optionsStatus = []
        for (let index = 1; index <= 8; index++) {
          optionsStatus.push({
            label: response[`status${index}_name`],
            value: `${index}`,
          })
        }
        this.optionsStatus = optionsStatus
        const itemQuestions = []
        for (let i = 1; i < 5; i++) {
          const item = {
            label: response[`question${i}`],
            placeholder: 'キーワードをスペースで区切り入力してください',
            rules: {
              // required: response[`question${i}_required`] === 1,
              required: false,
            },
            type: 'input',
            name: `answer${i}`,
          }
          if (response[`answer${i}`] === '' && response[`question${i}`]) {
            item.type = 'input'
            item.rules.max = 1000
          } else if (!response[`question${i}`]) {
            item.label = ''
            item.placeholder = ''
            item.type = null
          } else {
            const options = []
            const answers = response[`answer${i}`].split(',')
            if (response[`question${i}`]) {
              for (let j = 0; j < answers.length; j++) {
                options.push({ label: answers[j], value: answers[j] })
              }
            }
            item.options = options
            item.type = 'checkbox-group'
          }
          itemQuestions.push(item)
        }
        this.itemQuestions = itemQuestions
      }
    },
  },
}
</script>

<template>
  <div>
    <CRow
      v-for="item in [...items, ...itemQuestions, ...itemsBottom]"
      :key="item.name"
      class="d-flex align-items-baseline flex-wrap"
    >
      <CCol v-if="!item.label" sm="3" class="d-none"> </CCol>
      <CCol v-else sm="3">
        <div class="col-form-label"> </div>
        <div class="col-form-label">
          {{ item.label }}
          <span v-if="item.rules && item.rules.required" class="text-danger">
            *
          </span>
        </div>
      </CCol>
      <CCol sm="9">
        <template v-if="item.type === 'radio'">
          <BaseRadioGroup
            :vee-name="item.name"
            :disabled="view"
            :readonly="view"
            :checked.sync="fields[item.name]"
            inline
            custom
            :options="item.options"
            :rules="item.rules"
          />
        </template>
        <template v-if="item.type === 'number-ranger'">
          <BaseNumberInputRanger
            :vee-name-left="item.lower"
            :vee-name-right="item.upper"
            :disabled="view"
            :readonly="view"
            :min="item.rules.min"
            :max="item.rules.max"
            :label="item.unit"
            :left="fields[item.lower]"
            :right="fields[item.upper]"
            :rules="item.rules"
            @update:value="
              (v) => handleChangeRangeData(item.lower, item.upper, v)
            "
          />
        </template>
        <template v-if="item.type === 'checkbox-group'">
          <BaseCheckboxGroup
            :class-checkbox="item.class"
            :vee-name="item.name"
            custom
            inline
            :disabled="view"
            :readonly="view"
            :checked="(fields[item.name] || '').split(',')"
            :options="getCheckboxGroupOptions(item)"
            :rules="item.rules"
            @update:checked="(v) => handleChangeCheckboxGroup(item.name, v)"
          />
        </template>
        <template v-if="item.type === 'input'">
          <BaseInput
            :readonly="view"
            :disabled="view"
            :value.sync="fields[item.name]"
            :placeholder="item.placeholder"
            :vee-name="item.name"
            :rules="item.rules"
          />
        </template>
        <template v-if="item.type === 'date-ranger'">
          <BaseDateRangerPicker
            picker-type="datetime"
            :vee-name-start="item.lower"
            :vee-name-end="item.upper"
            :readonly="view"
            :disabled="view"
            :rules="item.rules"
            :rules-start="{
              requiredIfDate: {
                target: fields[item.upper],
              },
              ...item.rulesStart,
            }"
            :rules-end="{
              requiredIfDate: {
                target: fields[item.lower],
              },
              ...item.rulesEnd,
            }"
            :start-date="fields[item.lower]"
            :end-date="fields[item.upper]"
            @update:value="
              (v) => handleChangeDateRanger(item.lower, item.upper, v)
            "
          />
        </template>
      </CCol>
    </CRow>
  </div>
</template>

<style lang="scss" scoped>
.checkbox-group-w-50 {
  .custom-control {
    justify-content: start;
    width: calc(50% - 1.5rem);
  }
}
</style>
